<template>
  <div class="download_wrap">
    <section class="download_wrap_logo">
      <img class="logo" :src="zzLogo" alt="" />
      <img class="logo slogan" :src="zzSlogan" alt="" />
    </section>

    <section class="download_wrap_btn">
      <div class="btn" id="zz_download">
        {{ btnText }}
      </div>
      <div class="tips">
        {{ tips }}
      </div>
    </section>

    <div class="rules">
      <p>开发者：北京转转精神科技有限责任公司</p>
      <p class="details"><span>应用名称：转转</span><span>版本：{{ zzVersion }}</span></p>
      <p class="view">查看 <span @click="openPermission">应用权限</span> 和 <span @click="openPrivate">隐私政策</span></p>
      <p>版权所有：北京转转精神科技有限责任公司</p>
      <p>ICP：京ICP备17029143</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { initPage } from '../utils'
import native from '@zz-common/native-adapter'
import zzfetch from '@zz/fetch';

const zzLogo =
  'https://pic2.zhuanstatic.com/zhuanzh/c552d6a9-fd46-48e1-9283-45929e85054a.png?w=200&h=200'
const zzSlogan = 'https://img1.zhuanstatic.com/common/open/img/zz_slogan_changlaizz.png'
const tips = '如果不能正常打开转转，请在浏览器中打开之前链接'
const btnText = '立即打开'; // location.host.includes('mjump.zhuanzhuan.com') ? '立即下载' : '立即打开';

export default {
  name: 'ZZDownload',
  mounted() {
    initPage('#zz_download')
    zzfetch({
      url: `https://app.zhuanzhuan.com/zz/transfer/queryUpdateRemind?versionCode=${this.zzVersion}`,
      method: 'jsonp',
    })
      .then((res) => {
        if (res.respData && res.respData.versionNumber) {
          this.zzVersion = res.respData.versionNumber
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      zzLogo,
      zzSlogan,
      btnText,
      tips,
      zzVersion: '10.14.6',
    }
  },
  methods: {
    openPermission() {
      native.skipToUrl({ targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/636dbaf9ff4144006f532dcb/index.html?magicplatform=zz&needNewWebview=1' })
    },

    openPrivate() {
      native.skipToUrl({ targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/62981b3ead582a006595aa0a/index.html?magicplatform=zz&needNewWebview=1' })
    }
  }
}
</script>

<style lang="scss" scoped>
.download_wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &_logo {
    width: 100%;
    margin-top: 100px;
    margin-bottom: 75px;

    .logo {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
    }

    .slogan {
      width: 230px;
      height: 24px;
      margin: 0 auto;
      margin-top: 40px;
    }
  }

  &_btn {
    width: 100%;

    .btn {
      font-size: 15px;
      line-height: 43px;
      color: rgb(255, 0, 0);
      margin: 0 auto;
      width: 190px;
      height: 43px;
      background-color: #fff;
      // border: 1px solid rgb(163, 135, 135);
      letter-spacing: 1px;
    }

    .tips {
      margin: 10px auto;
      font-size: 12px;
      color: #9a9a9a;
      font-weight: 500;
    }
  }

  .rules {
    position: fixed;
    width: 100%;
    text-align: center;
    bottom: 20px;
    left: 0;
    color: #9a9a9a;

    .details span {
      margin-right: 10px;
    }

    .view span {
      text-decoration: underline;
    }
  }
}
</style>
